// notification-bell.component.ts
import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { interval, Observable, of, Subscription } from 'rxjs';
import { startWith, switchMap } from 'rxjs/operators';
import { NotificationService } from './bell-notif.service';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OrdersStore } from 'app/modules/raw-data/orders/orders.store';

@Component({
  selector: 'bell-notif',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule], // Import CommonModule directly
  templateUrl: './bell-notif.component.html',
  styleUrls: ['./bell-notif.component.scss']
})
export class BellNotifComponent implements OnInit, OnDestroy {
  
  private subscription: Subscription;
  notificationCount$ = this._notificationService.pendingCount$;
  value: number = 0;

  constructor(private _router: Router, private _route: ActivatedRoute, 
    private _changeDetectorRef: ChangeDetectorRef, private _notificationService: NotificationService,
    private _ordersStore: OrdersStore) {
  }

  ngOnInit(): void {
    this.subscription = this._notificationService.startPolling().subscribe(count => {
      this._changeDetectorRef.detectChanges();  // Trigger change detection to update the view
    });

    // Initially fetch the notification count
    this._notificationService.getNotificationCount().subscribe();
  }


  ngOnDestroy(): void {
    // Clean up the subscription when the component is destroyed
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onNotificationClick(): void {
    // Get the full URL of the current route
    const currentUrl = this._router.url;  // This gives the full URL path including the base
    
    console.log('Full current URL:', currentUrl);  // Debugging

    // Check if the current URL matches '/orders'
    if (currentUrl === '/orders') {
      this.handleOrdersRoute(); 
    } else {
      this._router.navigate(['/orders']);  // Navigate to '/orders' if not already on that route
    }
  }

  handleOrdersRoute(): void {
    this._ordersStore.getFilters().subscribe();
    // Handle your logic here
  }

}
